export default __webpack_public_path__ + "static/media/bimma-williams-960.faf39e02.jpg";